'use client';

import { useEffect, useState } from 'react';
import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ProfileSheet } from './header-profile.sheet.component';
import { ProfileSkeleton, LoginButtonSkeleton } from './header-navbar-profile.skeleton.component';

import { Button } from '@/components/ui/button/button.component';
import { getAuthSessionHint } from '@/storage/auth-session-hint.storage';
import { authStore } from '@/store/auth.store';
import { dismissSignInModal, modalsOpeningStore, setOpenSignInModal } from '@/store/modal';
import { LoginOriginEnum } from '@/types/enums/analytics/login/login-analytics.enum';
import { SignInModal } from '@/app/(main)/_components/sign-in-modal/sign-in-modal.component';

export function NavbarProfile() {
  const [mounted, setMounted] = useState(false);
  const [wasLoggedIn, setWasLoggedIn] = useState(false);
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);
  const isAuthReady = useStore(authStore, (state) => state.computed.isAuthReady);
  const openSignInModal = useStore(
    modalsOpeningStore,
    (state) => state.signInModalIsOpen,
  );
  const signInModalInitialStep = useStore(
    modalsOpeningStore,
    (state) => state.signInModalInitialStep,
  );

  useEffect(() => {
    setWasLoggedIn(getAuthSessionHint());
    setMounted(true);
  }, []);

  const handleSignIn = () => {
    setOpenSignInModal(true, { origin: LoginOriginEnum.HEADER });
  };

  if (!mounted) {
    return null;
  }

  if (!isAuthReady) {
    return wasLoggedIn ? <ProfileSkeleton /> : <LoginButtonSkeleton />;
  }

  if (isLoggedIn) {
    return <ProfileSheet />;
  }

  return (
    <>
      <Button
        data-testid={DataTestIdEnum.LOGIN_BUTTON}
        variant="outline"
        color="primary"
        className="text-sm lg:text-base h-8"
        onClick={handleSignIn}
      >
        Entrar
      </Button>
      <SignInModal
        isOpen={openSignInModal}
        setIsOpen={() => dismissSignInModal()}
        initialStep={signInModalInitialStep}
      />
    </>
  );
}
